import React, { useState, useEffect, useContext } from "react";

import lbl from "../../../data/Labels.json";

import Img from "../../common/Img";

import db from "../../../services/query";

import { PopUpContext } from "../../../contexts/popUpContext";

import ReportItemList from "./ReportItemList";
import ReportItemHeader from "../../common/ReportItemHeader";
import BenefitTypeList from "./BenefitTypeList";
import BenefitDetails from "./BenefitDetails";
import PlusIcon from "../../../icons/plus-icon";
import MainButton from "../../common/MainButton";


const BenefitProfile = (props) => {
  const { tid } = props.match.params;

  const [activeBenefit, setBenefit] = useState(0);
  const [activeYear, setYear] = useState(0);
  const [data, updateData] = useState([]);

  const { togglePopUp, popUp } = useContext(PopUpContext);

  useEffect(async () => {
    const ac = new AbortController();
    requestData();
    return () => ac.abort();
  }, [popUp]);

  const requestData = async () => {
    let query = `teachers/${tid}/salary`;

    await db.getAll(query).then(({ data }) => {
      updateData(data);
    });
  };

  return (
    <React.Fragment>
      <div className="finance-profile-area">
        <div className="std-profile">
          <div className="wrapper">
            <Img src={data?.summary?.teacher_photo} border={true} />
          </div>
        </div>
        <div className="overall-summary">
          <div className="wrapper">
            <p>{lbl.TotalBenefits}</p>
            <h1>{data?.summary?.total_benefit}</h1>
          </div>
        </div>
        <div className="controls">
          <MainButton
              type="add"
              title={lbl.AddBenefits}
              handleClick={() => togglePopUp({ form: "teacher-benefit-form", tid: tid})}
          />
        </div>
      </div>
      <div className="finance-report-area">
        <div className="report-container _75-per">
          <ReportItemHeader title={lbl.Details} />
          <BenefitDetails
              data={data?.data && data?.data[activeYear]?.benefits[activeBenefit]}
          />
        </div>

        <BenefitTypeList
          data={data?.data && data?.data[activeYear]?.benefits}
          setBenefit={setBenefit}
          activeBenefit={activeBenefit}
        />

        <div className="report-container _25-per">
          <ReportItemHeader title={lbl.Semester} />
          <ReportItemList
            data={data}
            setYear={setYear}
            activeYear={activeYear}
          />

        </div>
      </div>
    </React.Fragment>
  );
};

export default BenefitProfile;
